import Splide from '@splidejs/splide';

export default class VisualAccordion {
	constructor(wrapper) {

		this.mainslides 			= wrapper.querySelector('.b-list-slideshow__slides');
		this.thumbnails				= wrapper.querySelector('.b-list-slideshow__thumbnails');
		// this.track 				= this.mainslider.querySelector('.promo-ticker__group');

		if(this.mainslides){ 
			this.mainSlider = new Splide(this.mainslides, 
			{
				type		: 'slide',
				direction	: 'ttb',
				heightRatio	: 1.08,
				pagination 	: false,
				arrows     	: false,
				cover      	: true,
				perPage		: 10,
				drag		: false,
				isNavigation : true,
				autoHeight : true,
				pauseOnHover : false,
				noDrag 		: true,
				interval	: 4000,
				breakpoints: {
					1023: {
						direction	: 'ltr',
						isNavigation : false,
						destroy: true,
					}
				}
			})
		}

		if(this.thumbnails){ 
			this.thumbnailsSlider = new Splide( this.thumbnails, 
			{
				type			: 'fade',
				rewind          : true,
				pagination      : false,
				autoplay		: false,
				arrows 			: false,
				// interval		: 4000,
				// waitForTransition: true,
				pauseOnHover: false,
				breakpoints: {
					1023: {
						pagination: true,
						autoHeight: true,
						fixedHeight: false
					}
				}
			})
		}

		this.mainSlider.sync( this.thumbnailsSlider )
		this.thumbnailsSlider.mount()
		this.mainSlider.mount()

	}
}
